import {
    Navigate
} from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { JSX } from "react/jsx-runtime";


interface Props {
    children: JSX.Element;
    allowedRoles: string[];
}

const RoleProtectedRoute = ({
    children,
    allowedRoles
}: Props): JSX.Element => {

    const { isAuthenticated, role } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(role ?? "")) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default RoleProtectedRoute;